<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          v-if="permission('read', 'resident_medical_prescription')"
          @click="handleStep('PRESCRICAO_NORMAL')"
          :class="[
            'nav-link link-nav-resident',
            step == 'PRESCRICAO_NORMAL' && 'active',
          ]"
          id="nav-prescricao-normal"
          data-toggle="tab"
          href="#prescricao-normal"
          role="tab"
          aria-controls="prescricao-normal"
          aria-selected="true"
          >PRESCRIÇÃO MÉDICA</a
        >
        <a
          v-if="permission('read', 'resident_medical_prescription')"
          @click="handleStep('PRESCRICAO_LONGO_PRAZO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'PRESCRICAO_LONGO_PRAZO' && 'active',
          ]"
          id="nav-prescricao-longo-prazo"
          data-toggle="tab"
          href="#prescricao-longo-prazo"
          role="tab"
          aria-controls="prescricao-longo-prazo"
          aria-selected="true"
          >PRESCRIÇÃO MÉDICA LONGO PRAZO</a
        >
        <a
          v-if="permission('read', 'doctor_recipe')"
          @click="handleStep('RECEITA')"
          :class="['nav-link link-nav-resident', step == 'RECEITA' && 'active']"
          id="nav-receita"
          data-toggle="tab"
          href="#receita"
          role="tab"
          aria-controls="receita"
          aria-selected="false"
          >RECEITA MÉDICA</a
        >
        <a
          v-if="permission('read', 'digital_recipe')"
          @click="handleStep('MEMED')"
          :class="['nav-link link-nav-resident', step == 'MEMED' && 'active']"
          id="nav-evolucao"
          data-toggle="tab"
          href="#evolucao"
          role="tab"
          aria-controls="evolucao"
          aria-selected="false"
          >MEMED</a
        >
        <a
          v-if="permission('read', 'evolution_doctor')"
          @click="handleStep('EVOLUCAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'EVOLUCAO' && 'active',
          ]"
          id="nav-evolucao"
          data-toggle="tab"
          href="#evolucao"
          role="tab"
          aria-controls="evolucao"
          aria-selected="false"
          >EVOLUÇÃO MÉDICA</a
        >
        <a
          v-if="permission('read', 'box')"
          @click="handleStep('BOX')"
          :class="[
            'nav-link link-nav-resident highlighted-as-forward',
            step == 'BOX' && 'active',
          ]"
          id="nav-box"
          data-toggle="tab"
          href="#box"
          role="tab"
          aria-controls="box"
          aria-selected="false"
          >BOX</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="
          permission('read', 'resident_medical_prescription') &&
          step == 'PRESCRICAO_NORMAL'
        "
        :class="['tab-pane fade', step == 'PRESCRICAO_NORMAL' && 'show active']"
        id="prescricao-normal"
        role="tabpanel"
        aria-labelledby="nav-prescricao-normal"
      >
        <PrescriptionNormal :user_logged="user_logged" />
      </div>
      <div
        v-if="
          permission('read', 'resident_medical_prescription') &&
          step == 'PRESCRICAO_LONGO_PRAZO'
        "
        :class="[
          'tab-pane fade',
          step == 'PRESCRICAO_LONGO_PRAZO' && 'show active',
        ]"
        id="prescricao-longo-prazo"
        role="tabpanel"
        aria-labelledby="nav-prescricao-longo-prazo"
      >
        <PrescriptionLongTerm :user_logged="user_logged" />
      </div>
      <div
        v-if="step == 'RECEITA'"
        :class="['tab-pane fade', step == 'RECEITA' && 'show active']"
        id="receita"
        role="tabpanel"
        aria-labelledby="nav-receita"
      >
        <Recipe :resident="resident" />
      </div>
      <div
        v-if="step == 'EVOLUCAO'"
        :class="['tab-pane fade', step == 'EVOLUCAO' && 'show active']"
        id="evolucao"
        role="tabpanel"
        aria-labelledby="nav-evolucao"
      >
        <Evolution />
      </div>
      <div
        v-if="step == 'MEMED'"
        :class="['tab-pane fade', step == 'MEMED' && 'show active']"
        id="memed"
        role="tabpanel"
        aria-labelledby="nav-memed"
      >
        <DigitalRecipe :resident="resident" />
      </div>
      <div
        v-if="step == 'BOX'"
        :class="['tab-pane fade', step == 'BOX' && 'show active']"
        id="box"
        role="tabpanel"
        aria-labelledby="nav-box"
      >
        <Box :resident="resident" @configbox="$emit('configbox')" />
      </div>
    </div>
  </div>
</template>

<script>
import PrescriptionNormal from "./Doctor/Prescription/Normal";

import PrescriptionLongTerm from "./Doctor/Prescription/LongTerm";

import Evolution from "./Doctor/Evolution";

import Recipe from "./Doctor/Recipe";

import DigitalRecipe from "./Doctor/DigitalRecipe";

import Box from "./Box/Box";

import routes from "../../routes";

import permission from "../../lib/permission";

import api from "../../services/api";

export default {
  name: "MenuDoctor",
  components: {
    PrescriptionNormal,
    PrescriptionLongTerm,
    Evolution,
    Recipe,
    DigitalRecipe,
    Box,
  },
  props: {
    resident: Object,
  },
  data() {
    return {
      step: "PRESCRICAO_NORMAL",

      user_logged: null,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleStep(step) {
      let newNav;

      if (step == "PRESCRICAO_NORMAL") {
        newNav = "prescription-normal";
      }

      if (step == "PRESCRICAO_LONGO_PRAZO") {
        newNav = "prescription-long-term";
      }

      if (step == "RECEITA") {
        newNav = "recipe";
      }

      if (step == "EVOLUCAO") {
        newNav = "evolution";
      }

      if (step == "BOX") {
        newNav = "box";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "prescription-normal") {
          this.step = "PRESCRICAO_NORMAL";
        }

        if (nav == "prescription-long-term") {
          this.step = "PRESCRICAO_LONGO_PRAZO";
        }

        if (nav == "recipe") {
          this.step = "RECEITA";
        }

        if (nav == "evolution") {
          this.step = "EVOLUCAO";
        }

        if (nav == "box") {
          this.step = "BOX";
        }
      }
    },

    async getUserLogged() {
      try {
        const response = await api.get("/rest-home/user-logged");

        const { user, error } = response.data;

        if (!error) {
          this.user_logged = user;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
